import { useEffect, useState } from 'react';

/**
 * Subscribe to a media query and return whether it currently matches.
 * Defaults to false when window is unavailable (SSR / tests).
 */
export default function useMediaQuery(query: string, defaultValue = false): boolean {
  const [matches, setMatches] = useState(defaultValue);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mql = window.matchMedia(query);
    const handleChange = (event: MediaQueryListEvent) => setMatches(event.matches);

    // Sync initial value in case it differs from the default.
    setMatches(mql.matches);

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handleChange);
      return () => {
        mql.removeEventListener('change', handleChange);
      };
    }

    // Safari < 14 fallback
    mql.addListener(handleChange);
    return () => {
      mql.removeListener(handleChange);
    };
  }, [query]);

  return matches;
}

